import React, { useEffect, useState } from 'react';
import styled from 'styled-components';

interface IProps {
  itemName: string;
  onConfirm: () => void;
  onCancel: () => void;
  autoHideMs?: number;
}

const InlineConfirmDelete: React.FC<IProps> = ({ itemName, onConfirm, onCancel, autoHideMs = 5000 }) => {
  const [fading, setFading] = useState(false);

  useEffect(() => {
    const fadeTimer = setTimeout(() => setFading(true), autoHideMs - 300);
    const hideTimer = setTimeout(onCancel, autoHideMs);
    return () => {
      clearTimeout(fadeTimer);
      clearTimeout(hideTimer);
    };
  }, [autoHideMs, onCancel]);

  return (
    <Bar $fading={fading}>
      <Label>Delete <strong>{itemName}</strong>?</Label>
      <Actions>
        <CancelBtn onClick={onCancel}>Cancel</CancelBtn>
        <ConfirmBtn onClick={onConfirm}>Delete</ConfirmBtn>
      </Actions>
    </Bar>
  );
};

export default InlineConfirmDelete;

const Bar = styled.div<{ $fading: boolean }>`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 4px 8px;
  background: #ffebee;
  border: 1px solid #ef9a9a;
  border-radius: 4px;
  font-size: 12px;
  margin: 2px 0;
  opacity: ${(p) => (p.$fading ? 0 : 1)};
  transition: opacity 0.3s;
`;

const Label = styled.span`
  color: #c62828;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  min-width: 0;
  flex: 1;
`;

const Actions = styled.div`
  display: flex;
  gap: 4px;
  flex-shrink: 0;
  margin-left: 8px;
`;

const Btn = styled.button`
  border: none;
  border-radius: 3px;
  padding: 2px 8px;
  font-size: 11px;
  cursor: pointer;
  font-weight: 500;
`;

const CancelBtn = styled(Btn)`
  background: #fff;
  color: #666;
  border: 1px solid #ccc;
  &:hover {
    background: #f5f5f5;
  }
`;

const ConfirmBtn = styled(Btn)`
  background: #e53935;
  color: #fff;
  &:hover {
    background: #c62828;
  }
`;
